/**
 * Централізовані enum-и та константи для користувачів і ролей.
 * Імпортуйте звідси замість inline-рядків.
 */

// ─── User role ────────────────────────────────────────────────────────────────

export enum UserRole {
  Admin = 'admin',
  Dietitian = 'dietitian',
  Nurse = 'nurse',
  SeniorNurse = 'senior_nurse',
  Kitchen = 'kitchen',
  Warehouse = 'warehouse',
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.Admin]: 'Адміністратор',
  [UserRole.Dietitian]: 'Дієтолог',
  [UserRole.Nurse]: 'Медсестра',
  [UserRole.SeniorNurse]: 'Старша медсестра',
  [UserRole.Kitchen]: 'Кухня',
  [UserRole.Warehouse]: 'Комірник',
};
